import React from "react";
import {
  faArrowUpFromBracket,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useField } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

// Define the styled component outside the functional component
const UploadField = styled.div`
  position: relative;
  width: ${(props) => (props.fullWidth ? "100%" : "50%")};
  background-color: ${(props) =>
    props.fieldType === "secondary" ? "rgba(0, 0, 0, 0.06)" : "#fff"};
  border: ${(props) =>
    props.fieldType === "secondary" ? "none" : "1px solid #ced4da"};
  border-radius: ${(props) =>
    props.fieldType === "secondary" ? "0" : " 0.25rem"};
  height: ${(props) => (props.fieldType === "secondary" ? "56px" : "38px")};
  display: flex;
  align-items: center;
  padding: 12px;
  @media (max-width: 992px) {
    width: 100%;
  }
`;

const UploadFileField = ({
  fullWidth,
  formik,
  name,
  extension,
  fieldType = "secondary",
  removeFile = () => {},
}) => {
  const { t } = useTranslation();
  const [, meta] = useField(name);

  const handleFile = (file, key) => {
    formik.setFieldValue(key, file);
  };

  const handleRemoveFile = () => {
    removeFile();
    formik.setFieldValue(name, null);
  };

  const { name: fileName = "" } = formik.values[name] || {};

  const styleOption = {
    secondary: {
      color: "#00000080",
      fontSize: "0.89rem",
      fontWeight: "600",
      margin: "0 5px 0 0",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "90%",
    },
    primary: {
      color: fileName ? "#212529" : "#6c757d",
      fontSize: "1rem",
      fontWeight: "400",
      margin: "0 5px 0 0",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "90%",
    },
  };

  const errorStyleOption = {
    secondary: {
      color: "#d32f2f",
      fontFamily: '"Roboto","Helvetica","Arial","sans-serif"',
      fontWeight: 400,
      lineHeight: 1.66,
      letterSpacing: "0.03333em",
      textAlign: "left",
    },
    primary: {
      fontSize: "11px",
      color: "red",
      textAlign: "left !important",
    },
  };

  const renderFile = () => {
    if (fileName) {
      return fileName;
    } else if (fieldType === "secondary") {
      return (
        <>
          {t("document-upload-file-placeholder")}{" "}
          <span
            style={{
              color: "#00000080",
              fontSize: "0.89rem",
              fontWeight: "600",
              textDecoration: "underline",
            }}
          >
            browse
          </span>
        </>
      );
    } else {
      return "Upload Picture";
    }
  };

  return (
    <>
      <UploadField fullWidth={fullWidth} fieldType={fieldType}>
        <span className="w-100">
          <p style={styleOption[fieldType]}>{renderFile()}</p>
        </span>
        {!fileName ? (
          <>
            <input
              title=""
              type="file"
              accept={extension}
              style={{
                position: "absolute",
                opacity: "0",
                width: "100%",
                zIndex: "9999",
              }}
              onChange={(e) => handleFile(e.target.files[0], name)}
              onClick={(e) => {
                e.target.value = null;
              }}
            />
            <FontAwesomeIcon
              icon={faArrowUpFromBracket}
              style={{
                position: "absolute",
                right: "15px",
                color: "#00000065",
                cursor: "pointer",
              }}
            />
          </>
        ) : (
          <>
            <FontAwesomeIcon
              icon={faTimes}
              style={{ position: "absolute", right: "15px", cursor: "pointer" }}
              onClick={handleRemoveFile}
            />
          </>
        )}
      </UploadField>
      {meta && meta.touched && meta.error && (
        <p style={errorStyleOption[fieldType]}>{meta.error}</p>
      )}
    </>
  );
};

export default UploadFileField;
